import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/global.css'
import './i18n'
import App from './App'

// 静态样式 <link> (字体脱 bundle + tailwind): 生产 build 在 index.html 注入;
// dev HMR (bun HTML fullstack) 用 stripped HTML(避免 bun bundle resolve /fonts/),
// 故此处幂等补注入 — 生产已有则跳过, dev 缺失则补。
const STATIC_STYLESHEETS = [
  '/tailwind.css',
  '/fonts/geist/index.css',
  '/fonts/noto-sans-sc/index.css',
  '/fonts/noto-sans/index.css',
  '/fonts/jetbrains-mono/index.css',
]
for (const href of STATIC_STYLESHEETS) {
  if (!document.querySelector(`link[rel="stylesheet"][href="${href}"]`)) {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = href
    document.head.appendChild(link)
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
